import { transparentize } from "polished";
import React from "react";
import styled from "styled-components";
import { useAssessmentState } from "../../../../services/assessment-state";
import { AssessmentState } from "../../../../services/assessment-state/types";
import { colors } from "../../../../utils/colors";

const AgeInput = styled.input`
    background-color: ${transparentize(0.7, colors.brandDark)};
    border: 0;
    width: 100px;
    height: 100px;
    padding: 0;
    text-align: center;
    font-size: 58px;
    color: white;
    border-radius: 8px;

    &::placeholder {
        color: ${transparentize(0.75, "white")};
    }
`;

export const Age: React.FC = () => {
    const { state, isForSelf, setState } = useAssessmentState();

    const leadIn = isForSelf ? "I am" : "They are";

    return (
        <>
            <p>{leadIn}</p>
            <AgeInput
                type="tel"
                value={state.age}
                placeholder="00"
                onChange={e => {
                    if (e.target.value === "") {
                        setState({ age: e.target.value });
                    } else {
                        const amount = parseInt(e.target.value);
                        if (amount) {
                            setState({ age: String(amount) });
                        }
                    }
                }}
            />
            <p style={{ marginBottom: 0 }}>years old</p>
        </>
    );
};

export default {
    Component: Age,
    createMeta: (state: AssessmentState) => ({
        title:
            state.target === "MYSELF"
                ? "Let’s start with your age"
                : "How old is the person seeking support?",
        canProgress: state.age !== "",
        canSkip: false,
    }),
};
